import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ResidenteMatriculadoModel, SituacaoMatriculaDomainModel, SituacaoMatriculaEnum } from '@shared/models/backend'

@Component({
  selector: 'app-residente-card',
  templateUrl: './residente-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResidenteCardComponent {
  @Input()
  residente: ResidenteMatriculadoModel

  @Input()
  showCancelar: boolean

  @Input()
  showAnoResidencia: boolean

  @Input()
  isResidenciaMedica = false

  @Input() showVisualizarResidente = true

  @Output()
  cancelarClicked = new EventEmitter<ResidenteMatriculadoModel>()

  @Output()
  visualizarClicked = new EventEmitter<ResidenteMatriculadoModel>()

  getSituacaoResidenteAccent(situacao: SituacaoMatriculaDomainModel) {
    switch (situacao?.id) {
      case SituacaoMatriculaEnum.AGUARDANDO_CADASTRO:
        return 'blue'
      case SituacaoMatriculaEnum.MATRICULADO:
      case SituacaoMatriculaEnum.FERIAS:
        return 'teal'
      case SituacaoMatriculaEnum.ATESTADO_MEDICO_MAIS_QUINZE_DIAS:
      case SituacaoMatriculaEnum.LICENCA_MATERNIDADE:
      case SituacaoMatriculaEnum.PRORROGACAO_LICENCA:
      case SituacaoMatriculaEnum.TRANCAMENTO:
      case SituacaoMatriculaEnum.TRANCAMENTO_MILITAR:
        return 'warning'
      case SituacaoMatriculaEnum.SUSPENSO:
      case SituacaoMatriculaEnum.CADASTRO_INCOMPLETO:
        return 'red'
    }
    return 'grey'
  }

  onCancelarClicked() {
    this.cancelarClicked.emit(this.residente)
  }

  onVisualizarClicked() {
    this.visualizarClicked.emit(this.residente)
  }

  canShowCancelar = () => this.showCancelar

  canShowAnoResidencia = () => this.showAnoResidencia && this.residente?.anoResidencia

  isResidenciaMulti = () => !this.isResidenciaMedica

  get textAvatarDivStyle() {
    return (
      'max-width: 40px; margin-top: ' +
      (this.isResidenciaMulti() && this.residente?.categoriaProfissional ? '-3.2rem' : '-1.5rem')
    )
  }
}
